/* eslint-disable no-unused-vars */
import React from 'react';
import Navbar from '../GetStarted/Navbar';
import NavbarLower from '../GetStarted/NavbarLower';
import Grid from '@mui/material/Grid';
import Footer from './Footer';
import { useStyles,Item } from './SelfService';
import { Typography } from '@material-ui/core';
import {Card,CardContent, CardHeader} from "@material-ui/core";
import '../../App.css';
import { Alert } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import {PrivacyInformation } from '../../utils/index'


export const PrivacyPolicyContent=()=>{
  const classes =  useStyles();

  return(

    <Grid container style={{ padding:10 }}>
        <div>
    <p
      color="textPrimary"
      variant="h5"
      className={classes.formTitle}
      flexGrow={2}
    >
    Privacy Statement of PostBank Uganda Limited<span className={classes.value}></span>
    </p>
    {
      PrivacyInformation.map((info) => (
        <Grid item xs={12} md={12} key={info.id}>
        <Alert variant="filled"style={{backgroundColor: "#ffffff", color: "#039BE5", fontSize:16}}><b>{info.subject}</b></Alert>
          <Card>
            <CardContent>
            <p>{info.body.one}</p>
            <p>{info.body.two}</p>
            <p>{info.body.three}</p>
            <p>{info.body.four}</p>
            <p>{info.body.five}</p>
            <p>{info.body.six}</p>
            <p>{info.body.seven}</p>
            <p>{info.body.eight}</p>
            <p>{info.body.nine}</p>
            <p>{info.body.ten}</p>
            <p>{info.body.eleven}</p>
            </CardContent>
          </Card>
        <br/>
        </Grid>

    ))} 
    </div>
    </Grid>

  )
}

const PrivacyPolicy = () => {
    //Creating a responsive page layout
    return (
      <div>
          <NavbarLower/>
          <PrivacyPolicyContent/>
          <Footer/>
      </div>
  
    );
};


    
export default PrivacyPolicy;